/* HBI mega menu: rail switching, lazy images, live prices, brand search.
   Open/close of each dropdown is handled by Warehouse's DesktopNavigation (aria-hidden on .mega-menu). */
(function () {
  'use strict';
  var HOVER_DELAY = 120;

  function show(panel, id) {
    if (!panel || !id) return;
    var target = null;
    panel.querySelectorAll('.hbi-subpanel').forEach(function (sp) {
      var on = sp.getAttribute('data-hbi-id') === id;
      sp.hidden = !on;
      if (on) target = sp;
    });
    if (!target) return;
    panel.querySelectorAll('.hbi-rail-item').forEach(function (r) {
      r.classList.toggle('hbi-rail-item--active', r.getAttribute('data-subpanel') === id);
    });
    target.querySelectorAll('img[data-src]').forEach(function (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
    refreshPrices(target);
    fitHubs(target);
  }

  // Hub banner sits in the empty bottom of the middle column. Where the lists leave less room, shrink it to fit
  // (compact = title only); below 72px hide it, so the column never needs scrolling just to see it.
  function fitHubs(root) {
    var sp = root.matches('.hbi-subpanel') ? root : root.querySelector('.hbi-subpanel:not([hidden])');
    var band = sp && sp.querySelector('.hbi-hubband');
    if (!band || band.hasAttribute('data-hbi-fit')) return;
    var col = band.closest('.hbi-columns');
    if (!col || !col.clientHeight) return;  // dropdown still closed; try again when shown
    var tiles = band.querySelectorAll('.hbi-hub');
    var over = col.scrollHeight - col.clientHeight;
    if (over > 0) {
      var h = tiles[0].offsetHeight - over;
      if (h < 72) band.hidden = true;
      else {
        tiles.forEach(function (t) { t.style.height = h + 'px'; });
        band.classList.toggle('hbi-hubband--compact', h < 120);
      }
    }
    band.setAttribute('data-hbi-fit', '');
  }

  // Featured product prices are baked in at build time; refresh them from the storefront when shown.
  var priceCache = {};
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function refreshPrices(root) {
    root.querySelectorAll('a[data-hbi-product]').forEach(function (a) {
      var el = a.querySelector('.hbi-pprice');
      if (!el || a.hasAttribute('data-hbi-priced')) return;
      a.setAttribute('data-hbi-priced', '');
      var handle = a.getAttribute('data-hbi-product');
      var p = priceCache[handle] || (priceCache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }));
      p.then(function (prod) {
        if (!prod) return;
        el.textContent = (prod.price_varies ? 'From ' : '') + money(prod.price_min);
      });
    });
  }

  function init(dropdown) {
    var panel = dropdown.querySelector('.hbi-panel');
    if (!panel) return;
    var start = dropdown.getAttribute('data-hbi-start');
    if (start) show(panel, start);
    var timer = null;
    panel.querySelectorAll('.hbi-rail-item[data-subpanel]').forEach(function (item) {
      var id = item.getAttribute('data-subpanel');
      item.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { show(panel, id); }, HOVER_DELAY);
      });
      item.addEventListener('mouseleave', function () { clearTimeout(timer); });
      item.addEventListener('focus', function () { show(panel, id); });
      if (item.tagName === 'BUTTON') item.addEventListener('click', function () { show(panel, id); });
    });
    // Load the visible subpanel's prices when the dropdown opens
    new MutationObserver(function () {
      if (dropdown.getAttribute('aria-hidden') === 'false') {
        fillIn(dropdown);
        var vis = panel.querySelector('.hbi-subpanel:not([hidden])') || panel;
        refreshPrices(vis);
      }
    }).observe(dropdown, { attributes: true, attributeFilter: ['aria-hidden'] });
    if (dropdown.getAttribute('aria-hidden') === 'false') fillIn(dropdown);  // already open (e.g. editor preview)

    var input = panel.querySelector('[data-hbi-find-brand]');
    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase(), shown = 0;
        panel.querySelectorAll('[data-brand]').forEach(function (c) {
          var hit = !q || c.getAttribute('data-brand').indexOf(q) !== -1;
          c.hidden = !hit;
          if (hit) shown++;
        });
        var empty = panel.querySelector('[data-hbi-id="brand-empty"]');
        if (empty) empty.hidden = shown !== 0;
      });
    }
  }

  // Image-heavy extras (brands, featured product, guide bar) live in a static JSON asset, fetched once.
  // Its URL comes from the nav's data-hbi-extras attribute (Liquid asset_url, so it's CDN-cached and versioned).
  var extrasPromise = null, assetBase = '';
  function loadExtras() {
    if (extrasPromise) return extrasPromise;
    var holder = document.querySelector('[data-hbi-extras]');  // desktop nav bar and/or mobile drawer
    var url = window.HBI_MM_EXTRAS_URL || (holder && holder.getAttribute('data-hbi-extras'));
    assetBase = url ? url.split('?')[0].replace(/[^/]*$/, '') : '';  // theme assets folder, for {A} image paths in the JSON
    var src = window.HBI_MM_EXTRAS != null ? Promise.resolve(window.HBI_MM_EXTRAS) // local preview only
      : (url ? fetch(url).then(function (r) { return r.ok ? r.json() : null; }) : Promise.resolve(null));
    extrasPromise = src
      .then(function (data) { return (data && data.x) || null; })
      .catch(function () { extrasPromise = null; return null; });
    return extrasPromise;
  }
  // Fill extras only inside what the shopper actually opens, so images load for that panel alone
  // (the JSON itself is prefetched in the background and cached).
  function fillIn(root) {
    if (!root) return;
    loadExtras().then(function (map) {
      if (!map) return;
      root.querySelectorAll('.hbi-x[data-hbi-x]').forEach(function (slot) {
        var html = map[slot.getAttribute('data-hbi-x')];
        if (html != null) { slot.innerHTML = html.split('{A}').join(assetBase); slot.removeAttribute('data-hbi-x'); }
      });
      var vis = root.querySelector('.hbi-subpanel:not([hidden])');
      if (vis) { refreshPrices(vis); fitHubs(vis); }
    });
  }

  // Top bar: sliding underline that follows the pointer, page dim while a panel is open,
  // and instant panel swaps when moving from one item to the next (no close/open flicker).
  function initBar() {
    var bar = document.querySelector('.nav-bar.hbi-nav');
    if (!bar) return;
    var list = bar.querySelector('.nav-bar__linklist');
    var ink = document.createElement('span');
    ink.className = 'hbi-nav-ink';
    ink.setAttribute('aria-hidden', 'true');
    bar.appendChild(ink);  // anchored to the bar (already positioned), so dropdown positioning is untouched
    function moveInk(link) {
      if (!link || link.closest('.hbi-nav-item--deals, .hbi-nav-item--new')) { ink.classList.remove('is-on'); return; }
      var lr = bar.getBoundingClientRect(), r = link.getBoundingClientRect(), pad = 11;
      ink.style.width = Math.max(0, r.width - pad * 2) + 'px';
      ink.style.transform = 'translateX(' + (r.left - lr.left + pad) + 'px)';
      ink.classList.add('is-on');
    }
    function openLink() { return bar.querySelector('.nav-bar__link[aria-expanded="true"]'); }
    list.addEventListener('mouseover', function (e) {
      var a = e.target.closest('.nav-bar__link');
      if (a) moveInk(a);
    });
    list.addEventListener('focusin', function (e) {
      var a = e.target.closest('.nav-bar__link');
      if (a) moveInk(a);
    });
    bar.addEventListener('mouseleave', function () { setTimeout(function () { moveInk(openLink()); }, 160); });

    var lastClose = 0;
    var dropdowns = bar.querySelectorAll('.hbi-mm-dropdown');
    dropdowns.forEach(function (d) {
      new MutationObserver(function () {
        var open = d.getAttribute('aria-hidden') === 'false';
        if (open) {
          // Moving between top-level items: Warehouse opens the next dropdown BEFORE it closes the
          // current one, so "another one is open right now" is the real switch signal (the
          // close-then-open timer below only catches the rarer reverse order). Without this the old
          // stage fades out while the new one is still delayed, and the page shows through as a
          // white flash for ~100 ms (measured 2026-10-26: combined opacity dipped to 39%).
          var another = false;
          for (var i = 0; i < dropdowns.length; i++) {
            if (dropdowns[i] !== d && dropdowns[i].getAttribute('aria-hidden') === 'false') { another = true; break; }
          }
          if (another || Date.now() - lastClose < 260) {
            document.documentElement.classList.add('hbi-switching');
            setTimeout(function () { document.documentElement.classList.remove('hbi-switching'); }, 320);
          }
        } else {
          lastClose = Date.now();
        }
        // let a swap settle before deciding whether to undim
        setTimeout(function () {
          var any = bar.querySelector('.hbi-mm-dropdown[aria-hidden="false"]');
          document.body.classList.toggle('hbi-menu-open', !!any);
          if (!any && !bar.matches(':hover')) ink.classList.remove('is-on');
        }, 60);
      }).observe(d, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  // Long rails: fade + "More" button while there is more below; hidden at the end of the list.
  function initRailHints(root) {
    root.querySelectorAll('.hbi-rail-items-scroll').forEach(function (box) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hbi-rail-more';
      btn.innerHTML = 'More <span aria-hidden="true">&#8595;</span>';
      btn.addEventListener('click', function () { box.scrollBy({ top: 150, behavior: 'smooth' }); });
      box.insertAdjacentElement('afterend', btn);
      function update() {
        var more = box.scrollHeight - box.clientHeight - box.scrollTop > 6;
        box.classList.toggle('is-more', more);
        btn.classList.toggle('is-on', more);
      }
      box.addEventListener('scroll', update, { passive: true });
      new MutationObserver(update).observe(box.closest('.hbi-mm-dropdown'), { attributes: true, attributeFilter: ['aria-hidden'] });
      update();
    });
  }

  // Full-width panels that scroll (Brands): a sticky "More ↓" pill while there is more below; hidden at the end.
  // Overlay scrollbars on Mac/iOS auto-hide, so without this there is no visible cue that the list continues.
  function initPanelMore(root) {
    root.querySelectorAll('.hbi-panel--full').forEach(function (panel) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hbi-panel-more';
      btn.innerHTML = (panel.querySelector('.hbi-brands-panel') ? 'More brands' : 'More') + ' <span aria-hidden="true">&#8595;</span>';
      btn.addEventListener('click', function () { panel.scrollBy({ top: 240, behavior: 'smooth' }); });
      panel.appendChild(btn);
      function update() {
        btn.classList.toggle('is-on', panel.scrollHeight - panel.clientHeight - panel.scrollTop > 8);
      }
      panel.addEventListener('scroll', update, { passive: true });
      var dd = panel.closest('.hbi-mm-dropdown');
      if (dd) new MutationObserver(function () { setTimeout(update, 60); }).observe(dd, { attributes: true, attributeFilter: ['aria-hidden'] });
      update();
    });
  }

  // Line every panel up with the top bar: left edge of the first item to right edge of the last.
  function alignPanels() {
    var bar = document.querySelector('.nav-bar.hbi-nav');
    if (!bar) return;
    var links = bar.querySelectorAll('.nav-bar__linklist > .nav-bar__item > .nav-bar__link');
    if (!links.length) return;
    var first = links[0].getBoundingClientRect(), last = links[links.length - 1].getBoundingClientRect();
    bar.querySelectorAll('.hbi-mm').forEach(function (mm) {
      mm.style.marginLeft = '0px';
      mm.style.width = '';
      var box = mm.getBoundingClientRect();  // natural position, before any offset
      // never let the card run past the viewport, even if the bar itself overflows on a narrow window
      var vw = document.documentElement.clientWidth, left = Math.max(first.left, 12), right = Math.min(last.right, vw - 12);
      mm.style.marginLeft = Math.round(left - box.left) + 'px';
      mm.style.width = Math.round(right - left) + 'px';
    });
  }

  // The mobile drawer's nested panels (~2,400 DOM nodes, a duplicate of the desktop links) ship inert inside
  // <template> and are cloned in when the hamburger is tapped - capture phase, so Warehouse's open-panel
  // handler finds them. Desktop panels stay live in the DOM so their internal links remain crawlable.
  function materializeMobile() {
    var tpl = document.querySelector('#mobile-menu template.hbi-m-tpl');
    if (!tpl) return;
    tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl);
    tpl.remove();
  }

  function boot() {
    // Mobile drawer: panels in when the drawer is toggled; fill each nested panel as it is opened.
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-action="toggle-menu"]')) materializeMobile();
      var b = e.target.closest('#mobile-menu [data-action="open-panel"]');
      if (b) fillIn(document.getElementById(b.getAttribute('aria-controls')));
    }, true);
    var mm = document.getElementById('mobile-menu');
    if (mm && mm.getAttribute('aria-hidden') === 'false') materializeMobile();  // already open (editor)
    // Prefetch the extras JSON when the shopper opens the menu (or once the page is idle).
    document.querySelectorAll('[data-action="toggle-menu"]').forEach(function (b) { b.addEventListener('click', loadExtras, { once: true }); });
    if (!document.querySelector('.hbi-mm-dropdown')) {
      if (document.querySelector('.hbi-m-extra, template.hbi-m-tpl')) {
        var idleM = window.requestIdleCallback || function (fn) { return setTimeout(fn, 2500); };
        window.addEventListener('load', function () { idleM(loadExtras, { timeout: 4000 }); });
      }
      return;
    }
    document.querySelectorAll('.hbi-mm-dropdown').forEach(init);
    initBar();
    initRailHints(document);
    initPanelMore(document);
    alignPanels();
    var t = null;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(alignPanels, 120); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(alignPanels);
    // Load when the shopper heads for the menu, or once the page is idle, whichever comes first.
    var nav = document.querySelector('.nav-bar');
    if (nav) ['pointerenter', 'focusin', 'touchstart'].forEach(function (ev) { nav.addEventListener(ev, loadExtras, { once: true, passive: true }); });
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 2500); };
    window.addEventListener('load', function () { idle(loadExtras, { timeout: 4000 }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
